var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interview-layout",style:(_vm.style && _vm.isStyled && _vm.style.template !== 'BASIC_NEW'
      ? {
          backgroundColor: _vm.style.bgColor,
          backgroundImage: ("url(" + (_vm.style.bgImage) + ")")
        }
      : '')},[_c('router-view'),_c('app-footer',{attrs:{"with-help":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }